<template>
  <div class="table-responsive">
    <table class="table table-hover border-bottom" id="dataTable" width="100%" cellspacing="0">
      <thead>
        <tr style="color:#48a6a6;background-color:#f4f8fa;">
          <th>Title</th>
          <th>Category</th>
          <!-- <th>Views</th> -->
          <th>Published</th>
          <th>Featured</th>
          <!-- <th title="Recommendations">Recom.</th> -->
          <th>Comments</th>
          <!-- <th v-if="typeof $route.params.user === 'undefined'">
            <router-link to="/users">Author</router-link>
          </th> -->
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="isLoader" id="table_row">
          <td colspan="16">
            <b-skeleton-wrapper>
              <b-skeleton height="40px"></b-skeleton>
              <b-skeleton height="40px"></b-skeleton>
              <b-skeleton height="40px"></b-skeleton>
            </b-skeleton-wrapper>
          </td>
        </tr>
        <post-row v-show="!isLoader" v-for="post in posts" :post="post" :key="post.id" @skLoader="skloader"></post-row>
        <tr v-if="posts.length === 0" >
          <td colspan="6">No Data Found.</td>
        </tr>
      </tbody>
    </table>
    <paginate v-if="!isLoader" v-model="currentPage" :page-count="totalPages" :click-handler="setPage" :prev-text="''"
      :next-text="''" :first-button-text="''" :last-button-text="''" :first-last-button="true"
      :container-class="'pagination pagination-sm pt-3 mb-0 mr-3 float-right'" :page-class="'page-item'"
      :prev-class="'page-item prev'" :next-class="'page-item next'" :page-link-class="'page-link'"
      :prev-link-class="'page-link'" :next-link-class="'page-link'"></paginate>
  </div>
</template>

<script>
import PostRow from './post_row';

export default {
  components: {
    PostRow
  },


  data: function () {
    return {
      isLoader: true,
    }
  },
  props: [
    'posts', 'totalPages', 'page', 'setSkeletonLoader'
  ],
  mounted: function () {
    this.showskLoader = this.setSkeletonLoader;
  },
  computed: {
    currentPage: {
      get: function () {
        return this.page;
      },
      set: function () { }
    },
    showskLoader: {
      get: function () {
        return this.setSkeletonLoader
      },
      set: function (val) {
        this.isLoader = val;
        return val;
      },
    },
  },
  watch: {
    showskLoader: function (val) {
      this.isLoader = val;
      return val;
    }
  },
  methods: {
    setPage(page) {
      this.$emit('setPage', page);
    },
    skloader(val) {
      this.isLoader = val;
    }
  }
}
</script>

<style>
.table {
  font-size: 14px;
  font-weight: 400;
}

.table td {
  vertical-align: middle;
}

.table-hover tbody tr:hover td,
.table-hover tbody tr:hover th {
  background-color: #F4F8FA;
}
</style>

<style scoped>
.table {
  text-align: center;
  padding: hihihi;
}

.table tr th:not(:nth-child(5)):not(:nth-child(6)) {
  text-align: left !important;
}

.table tr th:nth-child(5):nth-child(6) {
  text-align: center !important;
}
</style>